<p-error-notification
  [visible]="!!errorStatus && errorStatus !== 404"
  [message]="errorMessage ?? ''"
  [status]="errorStatus"
  (notificationClick)="onNotificationClick()"
></p-error-notification>
<form id="details-dossier-form" class="px-4" [formGroup]="detailsDossierForm">
  <div class="row mb-3">
    <div class="col-6">
      <p-input
        [formControl]="this.detailsDossierForm.controls.reference"
        id="reference"
        name="reference"
        label="Référence du dossier"
        (input)="referenceChanged($event)"
        [errorMessage]="getErrorMessage('reference')"
      ></p-input>
    </div>
    <div class="col-6">
      <p-input
        [formControl]="this.detailsDossierForm.controls.date"
        type="date"
        id="date"
        name="date"
        label="Date du dossier"
        (input)="dateChanged($event)"
      ></p-input>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <p-input
        [formControl]="this.detailsDossierForm.controls.address"
        id="address"
        name="address"
        label="Adresse"
        (input)="addressChanged($event)"
        [disabled]="true"
      ></p-input>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <p-input
        [formControl]="this.detailsDossierForm.controls.connectionToTheProperty"
        id="connectionToTheProperty"
        name="connectionToTheProperty"
        label="Lien avec l’immeuble à expertiser"
        (input)="connectionToThePropertyChanged($event)"
      ></p-input>
    </div>
  </div>

  <div class="mb-3">
    <p-textarea
      [formControl]="this.detailsDossierForm.controls.purpose"
      id="purpose"
      name="purpose"
      label="Finalité pour laquelle l'évaluation est demandée"
      [maxLength]="2500"
      [showCounter]="true"
      (input)="purposeChanged($event)"
    ></p-textarea>
  </div>

  <div class="mb-3">
    <p-textarea
      [formControl]="this.detailsDossierForm.controls.comments"
      id="comments"
      name="comments"
      label="Commentaires"
      [maxLength]="2500"
      [showCounter]="true"
      (input)="commentsChanged($event)"
    ></p-textarea>
  </div>
</form>
